import React from 'react'
import StreamControl from 'components/panels/StreamControl'
import { SearchStream, HomeStream, StreamsStream } from 'components/filters/FilterIcon'
import cn from 'classnames'
import useStore from 'state/knovStore'
import styles from 'components/panels/control.module.scss'
import WithTooltip from 'components/shared/WithTooltip'
import { isMobile } from 'lib/device'
import { getCenterPanel } from 'state/imperativeApis/swiperApi'
import { FloatingSignupButton } from 'components/panels/Control'

export default function PublicControl({ showFilterOptions, setShowFilterOptions }) {
    useStore(state => state.activeIndex)
    const panel = getCenterPanel()
    const filter = panel?.filter
    const streamsSelectedStyles = filter?.streams ? styles.selectedIcon : null

    return (
        <div className={styles.controlComp}>
            <FloatingSignupButton />
            <div
                data-bottom-navigation
                className={cn(styles.lowerLevelContainer, isMobile && styles.mobileControl)}
            >
                <div
                    className={cn(styles.publicControlContainer, isMobile && styles.mobileNavItem)}
                >
                    <div className={styles.publicControl}>
                        <WithTooltip tip="Home" place="top">
                            <HomeStream
                                filter={filter}
                                panel={panel}
                                contextStyles={cn(styles.publicControl)}
                                append
                            />
                        </WithTooltip>
                    </div>
                </div>

                {isMobile ? (
                    <div className={cn(styles.controlGroup, styles.mobileNavItem)}>
                        <div className={styles.streamControlContainer}>
                            <StreamsStream
                                disable={false}
                                tip="Choose Channel"
                                insertNewPanel={false}
                                contextStyles={cn(styles.streamControl, styles.controlIcon)}
                                iconContextStyles={styles.controlIcon}
                                selectedStyles={streamsSelectedStyles}
                            />
                        </div>
                    </div>
                ) : (
                    <div className={styles.controlGroup}>
                        <div className={styles.streamControlContainer}>
                            <WithTooltip tip="Choose Channel" place="top">
                                <StreamControl
                                    panel={panel}
                                    filter={filter}
                                    showFilterOptions={showFilterOptions}
                                    setShowFilterOptions={setShowFilterOptions}
                                    contextStyles={cn(styles.streamControl)}
                                />
                            </WithTooltip>
                        </div>
                    </div>
                )}

                <div className={cn(styles.searchStreamContainer, isMobile && styles.mobileNavItem)}>
                    <SearchStream
                        filter={filter}
                        panel={panel}
                        contextStyles={cn(styles.searchIcon, styles.controlIcon)}
                        tip="Search"
                        place="top"
                        append
                    />
                </div>
            </div>
        </div>
    )
}
